module.exports = __webpack_public_path__ + "img/32.6e828f2d.jpg";